/**
 * Format a GTFS seconds-since-midnight value as "HH:MM".
 *
 * Unlike `dateTimeUtils.minutesToTime` (which normalizes >24h into the day, e.g.
 * 25:30 → 01:30), this PRESERVES after-midnight GTFS hours (24:xx, 25:xx) so a trip
 * that runs past midnight reads as part of the same service day. Pure seconds-of-day
 * arithmetic — no timezone / wall-time involved.
 */
export function secondsToHHMM(seconds: number | null | undefined): string {
  if (seconds == null || !Number.isFinite(seconds) || seconds < 0) return '—';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}
